import { render, staticRenderFns } from "./FeeSelection.vue?vue&type=template&id=352564fc&scoped=true&"
import script from "./FeeSelection.vue?vue&type=script&lang=js&"
export * from "./FeeSelection.vue?vue&type=script&lang=js&"
import style0 from "./FeeSelection.vue?vue&type=style&index=0&id=352564fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352564fc",
  null
  
)

component.options.__file = "FeeSelection.vue"
export default component.exports